import {
  AddressField,
  CheckboxField,
  ComplexRadioField,
  DateField,
  EmailField,
  HeadingField,
  HeightField,
  LinkField,
  PhoneField,
  RadioField,
  SSNField,
  SearchField,
  SelectField,
  TableField,
  TextAreaField,
  TextBlockField,
  TextField,
  WeightField,
  YearMonthDateField,
} from './FormFields'

import { FormFieldDto } from '../../interface/enrollmentApplication/EnrollementQuestionnaireSchema'
import React from 'react'
import { getDateValidationForField } from '../../utils/EnrollmentApplicationFormUtils'

type FormFieldRendererProps = {
  field: FormFieldDto
  value: any
  onChange: (value: any) => void
  error?: string
  formData?: any
  updateField?: (fieldId: string, value: any, sectionId?: any) => void
  isRequired?: boolean
}

export const FormFieldRenderer = ({
  field,
  value,
  onChange,
  error,
  formData,
  updateField,
  isRequired,
}: FormFieldRendererProps) => {
  const props = {
    field,
    value,
    onChange,
    error,
    isRequired,
    formData,
    updateField,
  }

  switch (field.type) {
    case 'text_field':
      return <TextField {...props} />

    case 'text_area_field':
      return <TextAreaField {...props} />

    case 'radio_field':
      return <RadioField {...props} />

    case 'checkbox_field':
      return <CheckboxField {...props} />

    case 'string_picker_field':
    case 'key_value_picker_field':
    case 'int_picker_field':
      return <SelectField {...props} />

    case 'complex_phone_field':
      return <PhoneField {...props} />

    case 'complex_date_picker_field':
      const customValidation = getDateValidationForField(field.id)
      const dateProps = { ...props, customValidation }

      if (
        [
          'medicare_part_a_eff_date',
          'medicare_part_a_eligibility_date',
          'medicare_part_b_eff_date',
          'medicare_part_b_eligibility_date',
        ].includes(field.id)
      ) {
        return <YearMonthDateField {...dateProps} />
      }
      return <DateField {...dateProps} />

    case 'ssn_field':
      return <SSNField {...props} />

    case 'height_field':
      return <HeightField {...props} />

    case 'weight_field':
      return <WeightField {...props} />

    case 'simple_email_field':
      return <EmailField {...props} />

    case 'heading_field':
      return <HeadingField {...props} />

    case 'text_block_field':
      return <TextBlockField {...props} />

    case 'string_search_field':
      return (
        <SearchField {...props} updateField={props.updateField ?? (() => {})} />
      )

    case 'complex_radio_field':
      return <ComplexRadioField {...props} />

    case 'input_table_field':
      return <TableField {...props} />

    case 'link_field':
      return <LinkField {...props} />

    case 'address_field':
      return <AddressField {...props} />

    default:
      return <TextField {...props} />
  }
}

export default FormFieldRenderer
